import { Component, OnInit, TemplateRef } from '@angular/core';
import { BsModalService } from 'ngx-bootstrap/modal';
import { Devicepersian_Interface, Empty_Devicepersian_Interface } from 'src/app/Interface/Devicepersian_Interface';
import { AlertifyService } from 'src/app/Service/Alertify.service';
import { DevicepersianService } from 'src/app/Service/Devicepersian/Devicepersian.service';
import { NavService } from 'src/app/Service/Nav/Nav.service';
import * as XLSX from 'xlsx';


@Component({
  selector: 'app-DevicepersianList',
  templateUrl: './DevicepersianList.component.html',
  styleUrls: ['./DevicepersianList.component.scss']
})
export class DevicepersianListComponent implements OnInit {
  Filter_title:string=""
  StartSearchDate:String=''
  EndSearchDate:String=''

  page:number=0;
  Procssing:boolean=false

  modalRef_Delete: any;

  constructor(
    private Devicepersian_Service:DevicepersianService,
    private Alertify_Service:AlertifyService,
    private Nav_Service:NavService,
    private modalService: BsModalService
  ) { }


  DataList_Devicepersian:Array<Devicepersian_Interface>=[]
  Data_Seleted_Delete:Devicepersian_Interface=Empty_Devicepersian_Interface()

  ngOnInit() {
    this.Nav_Service.CheckValidPage(1080).subscribe(
      data=>{
        //this.ReadData_Devicepersian()
      }
      ,error=>{
        // AuthInterceptor owns authentication; feature errors must preserve credentials.
      }
    )


  }

  ReadData_Devicepersian(StartSearchDate,EndSearchDate){
    this.Procssing=true
    this.StartSearchDate=StartSearchDate
    this.EndSearchDate=EndSearchDate
    this.Devicepersian_Service.GetRecord(
      StartSearchDate,
      EndSearchDate,
      this.Filter_title).subscribe(
      data=>{
        this.DataList_Devicepersian=data
        this.Procssing=false
      },error=>{
        // AuthInterceptor owns authentication; feature errors must preserve credentials.

      }
    )
  }

  Change_Filter_title(){
    this.page=0
  }

  Delete(item:Devicepersian_Interface){
    this.modalRef_Delete.hide()
    this.Devicepersian_Service.DeleteDevicepersian(item.id).subscribe(
      data=>{
        this.Alertify_Service.SuccessMessage("حذف شد")
        this.ReadData_Devicepersian(this.StartSearchDate,this.EndSearchDate)
      },error=>{
        // AuthInterceptor owns authentication; feature errors must preserve credentials.

      }
    )
  }

  openModal(template: TemplateRef<any>,Record) {
    this.Data_Seleted_Delete=Record
    this.modalRef_Delete = this.modalService.show(template);
  }



  exportexcel(): void
  {
     /* table id is passed over here */
     let element = document.getElementById('excel-table');
     const ws: XLSX.WorkSheet =XLSX.utils.table_to_sheet(element);

     /* generate workbook and add the worksheet */
     const wb: XLSX.WorkBook = XLSX.utils.book_new();
     XLSX.utils.book_append_sheet(wb, ws, 'Sheet1');

     /* save to file */
     XLSX.writeFile(wb, "DaroDevicepersian.xlsx");

  }


}
